import { createAction, props } from '@ngrx/store';
import { ViewColumnState } from "../../../../../application-controller/store/states/view-col.states";

export const cacheAgingPeriod = createAction('[View Cache] Cache Aging Period', props<{cache: ViewColumnState}>());
